import { useQuery } from "@tanstack/react-query";
import type { UseFormReturn } from "react-hook-form";

import type { TransferLineDraft } from "../../components/warehouseTransfer/transferLineItems.comp";
import { listRetailShops } from "../../core/retailShop.core";
import { getRetailWarehouse, listWarehouse } from "../../core/warehouse.core";

export type WarehouseTransferDetailFormValues = {
  fromWarehouseId: string;
  toRetailShopId: string;
  toWarehouseId: string;
  lines: TransferLineDraft[];
};

export type WarehouseTransferFormMethods = UseFormReturn<WarehouseTransferDetailFormValues>;

export function usePosWarehouseList() {
  return useQuery({
    queryKey: ["posWarehouseList"],
    queryFn: listWarehouse,
  });
}

export function useRetailShopsForTransfer() {
  return useQuery({
    queryKey: ["listRetailShopsTransfer"],
    queryFn: listRetailShops,
  });
}

export function useDestRetailWarehouses(retailShopId: string | undefined) {
  return useQuery({
    enabled: !!retailShopId,
    queryKey: ["getRetailWarehouse", retailShopId],
    queryFn: () => getRetailWarehouse(retailShopId!),
  });
}
